import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { track } from "./track";

export const useGtmPageView = () => {
  const location = useLocation();

  useEffect(() => {
    track.pageView(location.pathname);
  }, [location.pathname]);
};
